
/// <reference path="../membershipManager.module.ts" />
module Meevo.Plugins.MembershipManager {

    class ReasonModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            'titleTranslate',
            'labelTranslate'
        ];
        
        message: string;

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public titleTranslate: string,
            public labelTranslate: string) {
            
            this.message = '';
        }

        apply = () => {
            var vm = this;
            
            this.$mdDialog.hide({ message: this.message, status: true });
        };

        cancel = () => {
            this.$mdDialog.hide({ status: false });
        };
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.ReasonModalController", ReasonModalController);
}